export default "__VITE_ASSET__a878609c__"